/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".italicText[_ngcontent-%COMP%]{font-style:italic}.redText[_ngcontent-%COMP%]{color:#c00}.greenText[_ngcontent-%COMP%]{color:#090}"];
export { styles as styles };
